module.exports = __webpack_public_path__ + "static/media/office_9@2x.df6d217b.jpg";